module.exports = __webpack_public_path__ + "assets/image.7dc9cff2.svg";